import React from "react";
import { ArrowUpRight, ArrowDownRight } from "@phosphor-icons/react";

const KpiCard = ({ label, value, suffix = "", delta = null, icon: Icon, testId }) => {
  const positive = delta != null && delta >= 0;
  return (
    <div
      data-testid={testId}
      className="print-card relative bg-white border hairline rounded-sm p-5 md:p-6 grain overflow-hidden hover:shadow-md hover:border-myb-200 hover:-translate-y-0.5 transition-all duration-300 animate-fade-up"
    >
      <div className="flex items-center justify-between mb-3 relative z-10">
        <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground font-semibold">{label}</div>
        {Icon && <Icon weight="duotone" size={18} className="text-myb-500" />}
      </div>
      <div className="flex items-end gap-2 relative z-10">
        <div className="font-display text-3xl lg:text-4xl font-light tracking-tight text-foreground leading-none">
          {value}
        </div>
        {suffix && <div className="text-xs text-muted-foreground mb-1.5 uppercase tracking-wider font-semibold">{suffix}</div>}
      </div>
      {delta != null && (
        <div
          className={`mt-3 inline-flex items-center gap-1 text-xs relative z-10 font-medium ${
            positive ? "text-emerald-600" : "text-rose-600"
          }`}
        >
          {positive ? <ArrowUpRight size={14} /> : <ArrowDownRight size={14} />}
          <span>{Math.abs(delta).toFixed(1)}%</span>
          <span className="text-muted-foreground ml-1 font-normal">vs. prior year</span>
        </div>
      )}
      <div className="absolute -right-8 -bottom-8 w-32 h-32 rounded-full bg-myb-500/5 blur-2xl pointer-events-none" />
    </div>
  );
};

export default KpiCard;
